// @flow

// Constants
import {
  FARM,
} from 'fc-model-assets'

// Selectors
import makeAssetsOfCategory from './composers/makeAssetsOfCategory'

// Exports
export default makeAssetsOfCategory({
  category: FARM,
})
